module.exports = __webpack_public_path__ + "static/media/receipt.9749cb19.svg";